import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProductDetails } from '../../redux/features/Product/productThunk';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

import Details from './Components/Details';
import ProductHero from './Components/ProductHero';
import ProductDetails from './Components/ProductDetails';
import SimilarProduct from './Components/SimilarProduct';

function ProductPage() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('description');

  const { loading, error, product } = useSelector((state) => state.productDetails);

  useEffect(() => {
    if (id) {
      dispatch(fetchProductDetails(id));
    }
  }, [dispatch, id]);

  if (loading) return <Loader />;
  if (error) return <Message variant="danger" text={error} />;
  if (!product || !product._id) return <div className="text-center py-10">محصول پیدا نشد</div>;

  return (
    <div className="bg-background min-h-screen">
      <Details product={product} />
      <ProductHero product={product} />
      <ProductDetails
        product={product}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <SimilarProduct currentProduct={product} />
    </div>
  );
}

export default ProductPage;